import { render } from "./intelligentAlarm.vue?vue&type=template&id=f96704ae&scoped=true"
import script from "./intelligentAlarm.vue?vue&type=script&lang=js"
export * from "./intelligentAlarm.vue?vue&type=script&lang=js"

import "./intelligentAlarm.vue?vue&type=style&index=0&id=f96704ae&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f96704ae"]])

export default __exports__